import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { IPaymentState } from 'Redux/Slices/Payment/PaymentSlice';

type TPayload = { couponCode: string };

export const setCouponCode = (state: Draft<IPaymentState>, { payload }: PayloadAction<TPayload>) => {
  state.couponCode = payload.couponCode;
  state.updatedAt = Date.now();
};
